import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import { Row, Col } from 'react-flexbox-grid'
import config from 'config'
import container from '../../helpers/container'
import {
  ContainerDivs,
  Link,
  LinkIcon
} from '../../components'
import Styles from './IssuePage.css'

@CSSModules(Styles, {allowMultiple:true})
export default class IssueArmsManufacturers extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'The issue: Arms manufacturers',
      description: 'Through the global weapons trade, some arms manufacturers supply military goods to states at risk of using weapons for oppression or aggression.',
      url: config.domain + config.routes.issueArmsManufacturers
    }
  }

  render() {
    return (
      <div styleName='page issue-wff'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <section styleName='section'>
            <h1 styleName='issue-top-label'>
              The issue: <span>Arms manufacturers</span>
            </h1>
            <h2 styleName='issue-top-headline'>
              Weapon companies profit from military interventions
            </h2>
            <h3 styleName='issue-top-copy'>
              Through the global weapons trade, some arms manufacturers supply military goods to states at risk of using weapons for oppression or aggression.
            </h3>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={4}>
                <div styleName='issue-second-headline'>
                  <span style={{whiteSpace: 'nowrap'}}>&mdash;&mdash;&mdash;&mdash;</span>
                  <br/>
                  <h2>Retirement plans are invested in arms manufacturers and military contractors</h2>
                </div>
              </Col>
              <Col xs={12} md={8}>
                <div styleName='issue-second-copy'>
                  <p>
                    The largest U.S. mutual fund managers, responsible for funds found across thousands of corporate 401(k) plans, have significant investments in nuclear and other controversial weapons like cluster bombs and white phosphorus. While nations have the right to the legitimate use of weapons for self-defense and national security, having investor-owned arms manufacturers in retirement plans puts people in the position of profiting from this bloodshed.
                  </p>
                  <p>
                    Concerns about social impact, human rights, reputation risk, and regulatory risks are just a few of the reasons weapon-free investing has been a common component of sustainable investing for decades. These risks are amplified when companies are involved with nuclear weapons and controversial weapons like cluster munitions, anti-personnel landmines, incendiary weapons, and depleted uranium.
                  </p>
                  <p>
                    Given a choice, many would not want to profit from companies that manufacture weapons of mass destruction. We can help build a more peaceful world by shifting our investments away from war and violence.
                  </p>
                </div>
              </Col>
            </Row>
          </section>
          <section styleName='section'>
            <Row>
              <Col xs={12} md={6}>
                <div styleName='img-issue'/>
              </Col>
              <Col xs={12} md={6}>
                <div>
                  <h2 styleName='issue-focus-label'>
                    FOCUS: SUSTAINABILITY RISK
                  </h2>
                  <h3 styleName='issue-focus-headline'>
                    Nuclear weapons
                  </h3>
                  <div styleName='issue-focus-copy'>
                    <p>
                      The financing of companies contributing to the build-up and modernization of nuclear arms undermines efforts to achieve nuclear disarmament. Any use of nuclear weapons would violate fundamental rules of international law and have catastrophic humanitarian and environmental consequences.
                    </p>
                    <p>
                      <Link to={config.links.paxNuclearWeapons} title='PAX Cluster Muntions' xstrong>Research from peace groups PAX and ICAN</Link> has found that financial institutions are continuing to invest in publicly-traded manufacturers and servicers of nuclear weapons.
                    </p>
                    <p>
                      <Link
                        to={config.routes.companies + '#militaryweapons'}
                        title='Companies: Military weapons'
                        xstrong
                      >
                        Learn more<LinkIcon />
                      </Link>
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </section>
        </ContainerDivs>
        <div styleName='section-solutions-faq-background'>
          <ContainerDivs>
            <section styleName='section section-solutions-faq'>
              <Row>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-solutions-label'>
                      The Solutions
                    </h2>
                    <h3 styleName='issue-solutions-headline'>
                      Offer weapon-free retirement plan options
                    </h3>
                    <div styleName='issue-solutions-copy'>
                      <p>
                        Company retirement plans should offer fund options that are sustainably invested and exclude arms manufacturers and military contractors.
                      </p>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.solutionOfferSustainability}
                        title='Solution: Offer sustainability'
                        xstrong
                      >
                        Explore solutions<LinkIcon/>
                      </Link>
                    </div>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div styleName='section-solutions-faq-cell'>
                    <h2 styleName='issue-faqs-label'>
                      FAQs
                    </h2>
                    <div styleName='issue-faqs-headline'>
                      Answers to common questions about how retirement plans and asset managers are financing militarism.
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#do-i-have-to-sacrifice-returns-in-order-to-invest-sustainably-'}
                        title='Do I have to sacrifice returns in order to invest sustainably?'
                        xstrong
                      >
                        Do I have to sacrifice returns in order to invest sustainably?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-item'>
                      <Link
                        to={config.routes.faqs + '#why-should-retirement-plans-add-a-sustainable-investment-option-'}
                        title='Why should retirement plans add a sustainable investment option?'
                        xstrong
                      >
                        Why should retirement plans add a sustainable investment option?
                      </Link>
                    </div>
                    <div styleName='issue-faqs-link'>
                      <Link
                        to={config.routes.faqs}
                        title='FAQs'
                        xstrong
                      >
                      View all >>
                      </Link>
                    </div>
                  </div>
                </Col>
              </Row>
            </section>
            <br/>
            <br/>
          </ContainerDivs>
        </div>
      </div>
    )
  }
}
